// @flow

import Resource from 'speed-js-core/src/api/Resource';
import type { ID } from 'esm-web-pro/types/common';

export default class PaymentResource extends Resource {
    basePath: string = 'billing/payments/';

    objectPath: string = 'billing/payments/{ident}/';

    void(id: string): Promise<Object> {
        return this.client._request(`${this._getObjectPath(id)}void/`, 'PATCH', {});
    }

    connectToBillingAccount(id, data: { amount: string, billing_account: ID }) {
        return this.client._request(`${this._getObjectPath(id)}connect_to_billing_account/`, 'POST', data);
    }
}
